import { useUpdateGoalGroupBy } from 'features/user';
import { useUpdateUserSettings } from 'features/user/hooks/use-update-user-settings';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenu,
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
  PopupMenuTitle,
  PopupMenuToggle,
} from 'shared/components/ui/popup-menu';
import { useUser } from 'shared/hooks/use-user';
import { GoalGroupBy } from 'shared/types/sorting-mode';

import { groupByOptions } from './header-interaction-options';

export type ActiveMenuProps = {
  referenceElement: React.RefObject<HTMLElement>;
  onClose: () => void;
};

export const ActiveMenu: React.FC<ActiveMenuProps> = ({
  referenceElement,
  onClose,
}) => {
  const { t } = useTranslation();

  const user = useUser();
  const setGroupBy = useUpdateGoalGroupBy();

  const _onGroupBy = (value: GoalGroupBy) => {
    setGroupBy(value);
    onClose();
  };

  const updateUserSettings = useUpdateUserSettings();

  const groupBy = user?.settings?.goalGroupBy;
  const showCompletedGoals =
    user?.settings?.goalsOverview?.roadmap?.showCompletedGoals ?? true;

  const onShowCompletedGoals = (value: boolean) => {
    updateUserSettings({
      goalsOverview: {
        roadmap: {
          showCompletedGoals: value,
        },
      },
    });
  };

  return (
    <PopupMenu
      referenceElement={referenceElement}
      position="bottom-end"
      onOutside={onClose}
    >
      <PopupMenuList hasBottomBorder>
        <PopupMenuListItem>
          <PopupMenuToggle
            label={t('general.labels.goals.show-completed-goals')}
            checked={showCompletedGoals}
            onChange={onShowCompletedGoals}
          />
        </PopupMenuListItem>
      </PopupMenuList>
      <PopupMenuList>
        <PopupMenuTitle title={t('pages.goals.group-by.title')} isSubTitle />

        {groupByOptions.map(({ id, label, value }) => (
          <PopupMenuListItem key={id}>
            <PopupMenuButton
              start={groupBy === id ? <Icon icon={Check} /> : undefined}
              onClick={() => _onGroupBy(value)}
              indentationLevel={groupBy !== id ? 1 : 0}
            >
              {t(label)}
            </PopupMenuButton>
          </PopupMenuListItem>
        ))}
      </PopupMenuList>
    </PopupMenu>
  );
};
